// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IVerificationCodeRequestCreateDto
 */
export interface IVerificationCodeRequestCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IVerificationCodeRequestCreateDto
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof IVerificationCodeRequestCreateDto
     */
    type?: IVerificationCodeRequestCreateDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IVerificationCodeRequestCreateDto
     */
    is_link?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IVerificationCodeRequestCreateDto
     */
    employee_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IVerificationCodeRequestCreateDtoTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}


/**
 * Check if a given object implements the IVerificationCodeRequestCreateDto interface.
 */
export function instanceOfIVerificationCodeRequestCreateDto(value: object): value is IVerificationCodeRequestCreateDto {
    return true;
}

export function IVerificationCodeRequestCreateDtoFromJSON(json: any): IVerificationCodeRequestCreateDto {
    return IVerificationCodeRequestCreateDtoFromJSONTyped(json, false);
}

export function IVerificationCodeRequestCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IVerificationCodeRequestCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'type': json['type'] == null ? undefined : json['type'],
        'is_link': json['is_link'] == null ? undefined : json['is_link'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
    };
}

export function IVerificationCodeRequestCreateDtoToJSON(json: any): IVerificationCodeRequestCreateDto {
    return IVerificationCodeRequestCreateDtoToJSONTyped(json, false);
}

export function IVerificationCodeRequestCreateDtoToJSONTyped(value?: IVerificationCodeRequestCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'type': value['type'],
        'is_link': value['is_link'],
        'employee_id': value['employee_id'],
    };
}

